import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/projects/app-client/src/components/layout/DocsLayout/DocsLayout.jsx";
import CamExampleDrawing from "images/svgr/cam_example.svg";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SourceCode = makeShortcode("SourceCode");
const FlowDiagram = makeShortcode("FlowDiagram");
const Schematic = makeShortcode("Schematic");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A small showcase of documentation-supporting components integrated and in
various stages of planning/development as part of this spike.`}</p>
    <h2>{`Source Code`}</h2>
    <p>{`Source code is rendered using the `}<a parentName="p" {...{
        "href": "https://prismjs.com/"
      }}>{`Prism.js Syntax Highlighter`}</a>{`.
Additional attention can be called to specific lines by several forms of
decoration.`}</p>
    <SourceCode title="Source Code" mdxType="SourceCode">
      <div {...{
        "className": "gatsby-highlight",
        "data-language": "javascript"
      }}><pre parentName="div" {...{
          "className": "language-javascript"
        }}><code parentName="pre" {...{
            "className": "language-javascript"
          }}><span parentName="code" {...{
              "className": "token keyword"
            }}>{`import`}</span>{` React `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`from`}</span>{` `}<span parentName="code" {...{
              "className": "token string"
            }}>{`"react"`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span>{`

`}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`export`}</span>{` `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`const`}</span>{` `}<span parentName="code" {...{
              "className": "token function-variable function"
            }}>{`UniversalTag`}</span>{` `}<span parentName="code" {...{
              "className": "token operator"
            }}>{`=`}</span>{` `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token parameter"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{` tag `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` none`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{` children`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{` className`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`...`}</span>{`other `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{` `}<span parentName="code" {...{
              "className": "token operator"
            }}>{`=>`}</span>{` `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
`}<span parentName="code" {...{
              "className": "gatsby-highlight-code-line"
            }}>{`  `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`const`}</span>{` ImplTag `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` tag `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`?`}</span>{` tag `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` div`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`;`}</span></span>{`
`}<span parentName="code" {...{
              "className": "gatsby-highlight-code-line"
            }}>{`  `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`return`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span></span>{`    `}<span parentName="code" {...{
              "className": "token operator"
            }}>{`<`}</span>{`ImplTag `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="code" {...{
              "className": "token operator"
            }}>{`...`}</span>{`other`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{` className`}<span parentName="code" {...{
              "className": "token operator"
            }}>{`=`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`className`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span><span parentName="code" {...{
              "className": "token operator"
            }}>{`>`}</span>{`
      `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span><span parentName="code" {...{
              "className": "token string"
            }}>{`" "`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{`
`}<span parentName="code" {...{
              "className": "gatsby-highlight-code-line"
            }}></span>{`      `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`children`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{`
    `}<span parentName="code" {...{
              "className": "token operator"
            }}>{`<`}</span><span parentName="code" {...{
              "className": "token operator"
            }}>{`/`}</span>{`ImplTag`}<span parentName="code" {...{
              "className": "token operator"
            }}>{`>`}</span>{`
  `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span>{`
`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span></code></pre></div>
    </SourceCode>
    <h2>{`Directional Graph`}</h2>
    <p>{`Already demonstrated elsewhere are directional graphs; this example illustrates
a few different shapes as well as direct styling of elements.`}</p>
    <FlowDiagram title="Directional Graph" mdxType="FlowDiagram">
      <div {...{
        "className": "mermaid",
        "data-processed": "true"
      }}><svg parentName="div" {...{
          "id": "mermaid-1630067668555",
          "width": "100%",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlnsXLink": "http://www.w3.org/1999/xlink",
          "height": "158.51795959472656",
          "style": {
            "maxWidth": "409.69219970703125px"
          },
          "viewBox": "0 0 409.69219970703125 158.51795959472656"
        }}><style parentName="svg">{`#mermaid-1630067668555{font-family:"Open Sans",Helvetica,sans-serif;font-size:13;fill:#ffffff;}#mermaid-1630067668555 .error-icon{fill:#c61d23;}#mermaid-1630067668555 .error-text{fill:#f7f7f7;stroke:#f7f7f7;}#mermaid-1630067668555 .edge-thickness-normal{stroke-width:2px;}#mermaid-1630067668555 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1630067668555 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1630067668555 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1630067668555 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1630067668555 .marker{fill:#ffffff;stroke:#ffffff;}#mermaid-1630067668555 .marker.cross{stroke:#ffffff;}#mermaid-1630067668555 svg{font-family:"Open Sans",Helvetica,sans-serif;font-size:13;}#mermaid-1630067668555 .label{font-family:"Open Sans",Helvetica,sans-serif;color:#f7f7f7;}#mermaid-1630067668555 .cluster-label text{fill:#ffffff;}#mermaid-1630067668555 .cluster-label span{color:#ffffff;}#mermaid-1630067668555 .label text,#mermaid-1630067668555 span{fill:#f7f7f7;color:#f7f7f7;}#mermaid-1630067668555 .node rect,#mermaid-1630067668555 .node circle,#mermaid-1630067668555 .node ellipse,#mermaid-1630067668555 .node polygon,#mermaid-1630067668555 .node path{fill:#006298;stroke:#4cbfff;stroke-width:1px;}#mermaid-1630067668555 .node .label{text-align:center;}#mermaid-1630067668555 .node.clickable{cursor:pointer;}#mermaid-1630067668555 .arrowheadPath{fill:undefined;}#mermaid-1630067668555 .edgePath .path{stroke:#ffffff;stroke-width:1.5px;}#mermaid-1630067668555 .flowchart-link{stroke:#ffffff;fill:none;}#mermaid-1630067668555 .edgeLabel{background-color:#0d0d0d;text-align:center;}#mermaid-1630067668555 .edgeLabel rect{opacity:0.5;background-color:#0d0d0d;fill:#0d0d0d;}#mermaid-1630067668555 .cluster rect{fill:#003865;stroke:#006298;stroke-width:1px;}#mermaid-1630067668555 .cluster text{fill:#ffffff;}#mermaid-1630067668555 .cluster span{color:#ffffff;}#mermaid-1630067668555 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"Open Sans",Helvetica,sans-serif;font-size:12px;background:#007a6d;border:1px solid undefined;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1630067668555:root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"><g parentName="g" {...{
              "className": "output"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}></g><g parentName="g" {...{
                "className": "edgePaths"
              }}><g parentName="g" {...{
                  "className": "edgePath LS-A LE-B",
                  "id": "L-A-B",
                  "style": {
                    "opacity": "1"
                  }
                }}><path parentName="g" {...{
                    "className": "path",
                    "d": "M71.296875,73.0179672241211L75.46354166666667,73.0179672241211C79.63020833333333,73.0179672241211,87.96354166666667,73.0179672241211,96.3802085876465,73.10130055745442C104.79687550862631,73.18463389078777,113.29687601725261,73.35130055745442,117.54687627156578,73.43463389078777L121.79687652587891,73.5179672241211",
                    "markerEnd": "url(#arrowhead17)",
                    "style": {
                      "fill": "none"
                    }
                  }}></path><defs parentName="g"><marker parentName="defs" {...{
                      "id": "arrowhead17",
                      "viewBox": "0 0 10 10",
                      "refX": "9",
                      "refY": "5",
                      "markerUnits": "strokeWidth",
                      "markerWidth": "8",
                      "markerHeight": "6",
                      "orient": "auto"
                    }}><path parentName="marker" {...{
                        "d": "M 0 0 L 10 5 L 0 10 z",
                        "className": "arrowheadPath",
                        "style": {
                          "strokeWidth": "1",
                          "strokeDasharray": "1, 0"
                        }
                      }}></path></marker></defs></g><g parentName="g" {...{
                  "className": "edgePath LS-B LE-C",
                  "id": "L-B-C",
                  "style": {
                    "opacity": "1"
                  }
                }}><path parentName="g" {...{
                    "className": "path",
                    "d": "M232.3812641834123,54.0664204334123L241.8823029775506,49.89167823186376C251.38334177168895,45.71693603031523,270.38541935996557,37.367451627218166,286.2289060707705,34.41598525787719C302.0723927815755,31.464518888536208,314.7572886149089,33.91107055295132,321.0997365315755,35.134346385158885L327.4421844482422,36.35762221736644",
                    "markerEnd": "url(#arrowhead18)",
                    "style": {
                      "strokeWidth": "3px",
                      "stroke": "red",
                      "fill": "none"
                    }
                  }}></path><defs parentName="g"><marker parentName="defs" {...{
                      "id": "arrowhead18",
                      "viewBox": "0 0 10 10",
                      "refX": "9",
                      "refY": "5",
                      "markerUnits": "strokeWidth",
                      "markerWidth": "8",
                      "markerHeight": "6",
                      "orient": "auto"
                    }}><path parentName="marker" {...{
                        "d": "M 0 0 L 10 5 L 0 10 z",
                        "className": "arrowheadPath",
                        "style": {
                          "strokeWidth": "1",
                          "strokeDasharray": "1, 0"
                        }
                      }}></path></marker></defs></g><g parentName="g" {...{
                  "className": "edgePath LS-C LE-B",
                  "id": "L-C-B",
                  "style": {
                    "opacity": "1"
                  }
                }}><path parentName="g" {...{
                    "className": "path",
                    "d": "M327.4421844482422,58.08556568613918L321.0997365315755,60.57429927580282C314.7572886149089,63.06303286546648,302.0723927815755,68.04050004479379,289.4708305358887,70.61256696779077C276.86926829020183,73.18463389078777,264.3510396321615,73.35130055745442,258.0919253031413,73.43463389078777L251.83281097412114,73.5179672241211",
                    "markerEnd": "url(#arrowhead19)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    }
                  }}></path><defs parentName="g"><marker parentName="defs" {...{
                      "id": "arrowhead19",
                      "viewBox": "0 0 10 10",
                      "refX": "9",
                      "refY": "5",
                      "markerUnits": "strokeWidth",
                      "markerWidth": "8",
                      "markerHeight": "6",
                      "orient": "auto"
                    }}><path parentName="marker" {...{
                        "d": "M 0 0 L 10 5 L 0 10 z",
                        "className": "arrowheadPath",
                        "style": {
                          "strokeWidth": "1",
                          "strokeDasharray": "1, 0"
                        }
                      }}></path></marker></defs></g><g parentName="g" {...{
                  "className": "edgePath LS-B LE-E",
                  "id": "L-B-E",
                  "style": {
                    "opacity": "1"
                  }
                }}><path parentName="g" {...{
                    "className": "path",
                    "d": "M228.29200288492657,97.05877836507341L238.47458522881251,102.80197650824802C248.65716757269843,108.54517465142264,269.0223322604703,120.03157093777186,287.40022710435625,125.77476908094648C305.7781219482422,131.5179672241211,322.1687469482422,131.5179672241211,330.3640594482422,131.5179672241211L338.5593719482422,131.5179672241211",
                    "markerEnd": "url(#arrowhead20)",
                    "style": {
                      "strokeWidth": "3px",
                      "stroke": "green",
                      "fill": "none"
                    }
                  }}></path><defs parentName="g"><marker parentName="defs" {...{
                      "id": "arrowhead20",
                      "viewBox": "0 0 10 10",
                      "refX": "9",
                      "refY": "5",
                      "markerUnits": "strokeWidth",
                      "markerWidth": "8",
                      "markerHeight": "6",
                      "orient": "auto"
                    }}><path parentName="marker" {...{
                        "d": "M 0 0 L 10 5 L 0 10 z",
                        "className": "arrowheadPath",
                        "style": {
                          "strokeWidth": "1",
                          "strokeDasharray": "1, 0"
                        }
                      }}></path></marker></defs></g></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}><g parentName="g" {...{
                  "className": "edgeLabel",
                  "transform": "",
                  "style": {
                    "opacity": "1"
                  }
                }}><g parentName="g" {...{
                    "transform": "translate(0,0)",
                    "className": "label"
                  }}><rect parentName="g" {...{
                      "rx": "0",
                      "ry": "0",
                      "width": "0",
                      "height": "0"
                    }}></rect><foreignObject parentName="g" {...{
                      "width": "0",
                      "height": "0"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}><span parentName="div" {...{
                          "id": "L-L-A-B",
                          "className": "edgeLabel L-LS-A' L-LE-B"
                        }}></span></div></foreignObject></g></g><g parentName="g" {...{
                  "className": "edgeLabel",
                  "transform": "translate(289.3874969482422,29.017967224121094)",
                  "style": {
                    "opacity": "1"
                  }
                }}><g parentName="g" {...{
                    "transform": "translate(-10.2265625,-9)",
                    "className": "label"
                  }}><rect parentName="g" {...{
                      "rx": "0",
                      "ry": "0",
                      "width": "20.453125",
                      "height": "18"
                    }}></rect><foreignObject parentName="g" {...{
                      "width": "20.453125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}><span parentName="div" {...{
                          "id": "L-L-B-C",
                          "className": "edgeLabel L-LS-B' L-LE-C"
                        }}>{`No`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "className": "edgeLabel",
                  "transform": "",
                  "style": {
                    "opacity": "1"
                  }
                }}><g parentName="g" {...{
                    "transform": "translate(0,0)",
                    "className": "label"
                  }}><rect parentName="g" {...{
                      "rx": "0",
                      "ry": "0",
                      "width": "0",
                      "height": "0"
                    }}></rect><foreignObject parentName="g" {...{
                      "width": "0",
                      "height": "0"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}><span parentName="div" {...{
                          "id": "L-L-C-B",
                          "className": "edgeLabel L-LS-C' L-LE-B"
                        }}></span></div></foreignObject></g></g><g parentName="g" {...{
                  "className": "edgeLabel",
                  "transform": "translate(289.3874969482422,131.5179672241211)",
                  "style": {
                    "opacity": "1"
                  }
                }}><g parentName="g" {...{
                    "transform": "translate(-13.0546875,-9)",
                    "className": "label"
                  }}><rect parentName="g" {...{
                      "rx": "0",
                      "ry": "0",
                      "width": "26.109375",
                      "height": "18"
                    }}></rect><foreignObject parentName="g" {...{
                      "width": "26.109375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}><span parentName="div" {...{
                          "id": "L-L-B-E",
                          "className": "edgeLabel L-LS-B' L-LE-E"
                        }}>{`Yes`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "className": "node default",
                  "id": "flowchart-A-10",
                  "transform": "translate(39.6484375,73.0179672241211)",
                  "style": {
                    "opacity": "1"
                  }
                }}><rect parentName="g" {...{
                    "rx": "19",
                    "ry": "19",
                    "x": "-31.6484375",
                    "y": "-19",
                    "width": "63.296875",
                    "height": "38",
                    "className": "label-container",
                    "style": {
                      "fill": "green",
                      "stroke": "green"
                    }
                  }}></rect><g parentName="g" {...{
                    "className": "label",
                    "transform": "translate(0,0)"
                  }}><g parentName="g" {...{
                      "transform": "translate(-16.8984375,-9)"
                    }}><foreignObject parentName="g" {...{
                        "width": "33.796875",
                        "height": "18"
                      }}><div parentName="foreignObject" {...{
                          "xmlns": "http://www.w3.org/1999/xhtml",
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          }
                        }}>{`Start`}</div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "node default",
                  "id": "flowchart-B-11",
                  "transform": "translate(186.3148422241211,73.0179672241211)",
                  "style": {
                    "opacity": "1"
                  }
                }}><polygon parentName="g" {...{
                    "points": "65.01796875000001,0 130.03593750000002,-65.01796875000001 65.01796875000001,-130.03593750000002 0,-65.01796875000001",
                    "transform": "translate(-65.01796875000001,65.01796875000001)",
                    "className": "label-container",
                    "style": {
                      "fill": "#AA1807",
                      "stroke": "#CC4411",
                      "strokeWidth": "2px"
                    }
                  }}></polygon><g parentName="g" {...{
                    "className": "label",
                    "transform": "translate(0,0)"
                  }}><g parentName="g" {...{
                      "transform": "translate(-34.2421875,-18)"
                    }}><foreignObject parentName="g" {...{
                        "width": "68.484375",
                        "height": "36"
                      }}><div parentName="foreignObject" {...{
                          "xmlns": "http://www.w3.org/1999/xhtml",
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          }
                        }}>{`Add`}<br parentName="div"></br>{`Sriracha?`}</div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "node default",
                  "id": "flowchart-C-13",
                  "transform": "translate(364.5671844482422,43.517967224121094)",
                  "style": {
                    "opacity": "1"
                  }
                }}><rect parentName="g" {...{
                    "rx": "5",
                    "ry": "5",
                    "x": "-37.125",
                    "y": "-19",
                    "width": "74.25",
                    "height": "38",
                    "className": "label-container"
                  }}></rect><g parentName="g" {...{
                    "className": "label",
                    "transform": "translate(0,0)"
                  }}><g parentName="g" {...{
                      "transform": "translate(-27.125,-9)"
                    }}><foreignObject parentName="g" {...{
                        "width": "54.25",
                        "height": "18"
                      }}><div parentName="foreignObject" {...{
                          "xmlns": "http://www.w3.org/1999/xhtml",
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          }
                        }}>{`Rethink`}</div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "node default",
                  "id": "flowchart-E-17",
                  "transform": "translate(364.5671844482422,131.5179672241211)",
                  "style": {
                    "opacity": "1"
                  }
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "x": "-26.0078125",
                    "y": "-19",
                    "width": "52.015625",
                    "height": "38",
                    "className": "label-container"
                  }}></rect><g parentName="g" {...{
                    "className": "label",
                    "transform": "translate(0,0)"
                  }}><g parentName="g" {...{
                      "transform": "translate(-16.0078125,-9)"
                    }}><foreignObject parentName="g" {...{
                        "width": "32.015625",
                        "height": "18"
                      }}><div parentName="foreignObject" {...{
                          "xmlns": "http://www.w3.org/1999/xhtml",
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          }
                        }}>{`Yum`}</div></foreignObject></g></g></g></g></g></g></svg></div>
    </FlowDiagram>
    <p>{`The directional graph and other following graphs are composed using
`}<a parentName="p" {...{
        "href": "https://mermaid-js.github.io/mermaid/#/"
      }}>{`Mermaid`}</a>{`, which has extensive
`}<a parentName="p" {...{
        "href": "https://mermaid-js.github.io/mermaid/#/flowchart"
      }}>{`diagram syntax documentation`}</a>{`
as well as a
`}<a parentName="p" {...{
        "href": "https://mermaid-js.github.io/mermaid-live-editor/"
      }}>{`live diagram editor`}</a>{`.`}</p>
    <h2>{`Sequence Diagram`}</h2>
    <p>{`Another useful graph mermaid can render are sequence diagrams.`}</p>
    <FlowDiagram title="Sequence Diagram" mdxType="FlowDiagram">
      <div {...{
        "className": "mermaid",
        "data-processed": "true"
      }}><svg parentName="div" {...{
          "id": "mermaid-1630067668555",
          "width": "100%",
          "xmlns": "http://www.w3.org/2000/svg",
          "height": "361",
          "style": {
            "maxWidth": "787px"
          },
          "viewBox": "-50 -10 787 361"
        }}><style parentName="svg">{`#mermaid-1630067668555{font-family:"Open Sans",Helvetica,sans-serif;font-size:13;fill:#ffffff;}#mermaid-1630067668555 .error-icon{fill:#c61d23;}#mermaid-1630067668555 .error-text{fill:#f7f7f7;stroke:#f7f7f7;}#mermaid-1630067668555 .edge-thickness-normal{stroke-width:2px;}#mermaid-1630067668555 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1630067668555 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1630067668555 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1630067668555 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1630067668555 .marker{fill:#ffffff;stroke:#ffffff;}#mermaid-1630067668555 .marker.cross{stroke:#ffffff;}#mermaid-1630067668555 svg{font-family:"Open Sans",Helvetica,sans-serif;font-size:13;}#mermaid-1630067668555 .actor{stroke:#4cbfff;fill:#006298;}#mermaid-1630067668555 text.actor > tspan{fill:#f7f7f7;stroke:none;}#mermaid-1630067668555 .actor-line{stroke:grey;}#mermaid-1630067668555 .messageLine0{stroke-width:1.5;stroke-dasharray:none;stroke:#ffffff;}#mermaid-1630067668555 .messageLine1{stroke-width:1.5;stroke-dasharray:2,2;stroke:#ffffff;}#mermaid-1630067668555 #arrowhead path{fill:#ffffff;stroke:#ffffff;}#mermaid-1630067668555 .sequenceNumber{fill:#000000;}#mermaid-1630067668555 #sequencenumber{fill:#ffffff;}#mermaid-1630067668555 #crosshead path{fill:#ffffff;stroke:#ffffff;}#mermaid-1630067668555 .messageText{fill:#ffffff;stroke:#ffffff;}#mermaid-1630067668555 .labelBox{stroke:#4cbfff;fill:#006298;}#mermaid-1630067668555 .labelText,#mermaid-1630067668555 .labelText > tspan{fill:#f7f7f7;stroke:none;}#mermaid-1630067668555 .loopText,#mermaid-1630067668555 .loopText > tspan{fill:#f7f7f7;stroke:none;}#mermaid-1630067668555 .loopLine{stroke-width:2px;stroke-dasharray:2,2;stroke:#4cbfff;fill:#4cbfff;}#mermaid-1630067668555 .note{stroke:#ffc72c;fill:#ffc72c;}#mermaid-1630067668555 .noteText,#mermaid-1630067668555 .noteText > tspan{fill:#3f3f3f;stroke:none;}#mermaid-1630067668555 .activation0{fill:#575757;stroke:hsl(0,0%,24.1176470588%);}#mermaid-1630067668555 .activation1{fill:#575757;stroke:hsl(0,0%,24.1176470588%);}#mermaid-1630067668555 .activation2{fill:#575757;stroke:hsl(0,0%,24.1176470588%);}#mermaid-1630067668555:root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"></g><g parentName="svg"><line parentName="g" {...{
              "id": "actor0",
              "x1": "60",
              "y1": "5",
              "x2": "60",
              "y2": "350",
              "className": "actor-line",
              "strokeWidth": "0.5px",
              "stroke": "#999"
            }}></line><rect parentName="g" {...{
              "x": "0",
              "y": "0",
              "fill": "#eaeaea",
              "stroke": "#666",
              "width": "120",
              "height": "40",
              "rx": "3",
              "ry": "3",
              "className": "actor"
            }}></rect><text parentName="g" {...{
              "x": "60",
              "y": "20",
              "dominantBaseline": "central",
              "alignmentBaseline": "central",
              "className": "actor",
              "style": {
                "textAnchor": "middle",
                "fontSize": "13px",
                "fontWeight": "400",
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif"
              }
            }}><tspan parentName="text" {...{
                "x": "60",
                "dy": "0"
              }}>{`Moff Jerjerrod`}</tspan></text></g><g parentName="svg"><line parentName="g" {...{
              "id": "actor1",
              "x1": "446",
              "y1": "5",
              "x2": "446",
              "y2": "350",
              "className": "actor-line",
              "strokeWidth": "0.5px",
              "stroke": "#999"
            }}></line><rect parentName="g" {...{
              "x": "386",
              "y": "0",
              "fill": "#eaeaea",
              "stroke": "#666",
              "width": "120",
              "height": "40",
              "rx": "3",
              "ry": "3",
              "className": "actor"
            }}></rect><text parentName="g" {...{
              "x": "446",
              "y": "20",
              "dominantBaseline": "central",
              "alignmentBaseline": "central",
              "className": "actor",
              "style": {
                "textAnchor": "middle",
                "fontSize": "13px",
                "fontWeight": "400",
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif"
              }
            }}><tspan parentName="text" {...{
                "x": "446",
                "dy": "0"
              }}>{`Darth Vader`}</tspan></text></g><g parentName="svg"><line parentName="g" {...{
              "id": "actor2",
              "x1": "627",
              "y1": "5",
              "x2": "627",
              "y2": "350",
              "className": "actor-line",
              "strokeWidth": "0.5px",
              "stroke": "#999"
            }}></line><rect parentName="g" {...{
              "x": "567",
              "y": "0",
              "fill": "#eaeaea",
              "stroke": "#666",
              "width": "120",
              "height": "40",
              "rx": "3",
              "ry": "3",
              "className": "actor"
            }}></rect><text parentName="g" {...{
              "x": "627",
              "y": "20",
              "dominantBaseline": "central",
              "alignmentBaseline": "central",
              "className": "actor",
              "style": {
                "textAnchor": "middle",
                "fontSize": "13px",
                "fontWeight": "400",
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif"
              }
            }}><tspan parentName="text" {...{
                "x": "627",
                "dy": "0"
              }}>{`Lambda shuttle`}</tspan></text></g><defs parentName="svg"><marker parentName="defs" {...{
              "id": "arrowhead",
              "refX": "9",
              "refY": "5",
              "markerUnits": "userSpaceOnUse",
              "markerWidth": "12",
              "markerHeight": "12",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "crosshead",
              "markerWidth": "15",
              "markerHeight": "8",
              "orient": "auto",
              "refX": "16",
              "refY": "4"
            }}><path parentName="marker" {...{
                "fill": "black",
                "stroke": "#000000",
                "strokeWidth": "1px",
                "d": "M 9,2 V 6 L16,4 Z",
                "style": {
                  "strokeDasharray": "0, 0"
                }
              }}></path><path parentName="marker" {...{
                "fill": "none",
                "stroke": "#000000",
                "strokeWidth": "1px",
                "d": "M 0,1 L 6,7 M 6,1 L 0,7",
                "style": {
                  "strokeDasharray": "0, 0"
                }
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "filled-head",
              "refX": "18",
              "refY": "7",
              "markerWidth": "20",
              "markerHeight": "28",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 18,7 L9,13 L14,7 L9,1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "sequencenumber",
              "refX": "15",
              "refY": "15",
              "markerWidth": "60",
              "markerHeight": "40",
              "orient": "auto"
            }}><circle parentName="marker" {...{
                "cx": "15",
                "cy": "15",
                "r": "6"
              }}></circle></marker></defs><text parentName="svg" {...{
            "x": "537",
            "y": "55",
            "textAnchor": "middle",
            "dominantBaseline": "middle",
            "alignmentBaseline": "middle",
            "className": "messageText",
            "dy": "1em",
            "style": {
              "fontFamily": "\"Open Sans\", Helvetica, sans-serif",
              "fontSize": "13px",
              "fontWeight": "400"
            }
          }}>{`[dramatic entrance]`}</text><line parentName="svg" {...{
            "x1": "627",
            "y1": "80",
            "x2": "446",
            "y2": "80",
            "className": "messageLine0",
            "strokeWidth": "2",
            "stroke": "none",
            "markerEnd": "url(#arrowhead)",
            "style": {
              "fill": "none"
            }
          }}></line><g parentName="svg"><rect parentName="g" {...{
              "x": "85",
              "y": "90",
              "fill": "#EDF2AE",
              "stroke": "#666",
              "width": "239",
              "height": "35",
              "rx": "0",
              "ry": "0",
              "className": "note"
            }}></rect><text parentName="g" {...{
              "x": "205",
              "y": "95",
              "textAnchor": "middle",
              "dominantBaseline": "middle",
              "alignmentBaseline": "middle",
              "className": "noteText",
              "dy": "1em",
              "style": {
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif",
                "fontSize": "13px",
                "fontWeight": "400"
              }
            }}><tspan parentName="text" {...{
                "x": "205"
              }}>{`Act casual. Be cool. Everything's cool.`}</tspan></text></g><text parentName="svg" {...{
            "x": "253",
            "y": "140",
            "textAnchor": "middle",
            "dominantBaseline": "middle",
            "alignmentBaseline": "middle",
            "className": "messageText",
            "dy": "1em",
            "style": {
              "fontFamily": "\"Open Sans\", Helvetica, sans-serif",
              "fontSize": "13px",
              "fontWeight": "400"
            }
          }}>{`"Lord Vader, this is an unexpected pleasure."`}</text><line parentName="svg" {...{
            "x1": "60",
            "y1": "165",
            "x2": "446",
            "y2": "165",
            "className": "messageLine0",
            "strokeWidth": "2",
            "stroke": "none",
            "markerEnd": "url(#arrowhead)",
            "style": {
              "fill": "none"
            }
          }}></line><text parentName="svg" {...{
            "x": "253",
            "y": "180",
            "textAnchor": "middle",
            "dominantBaseline": "middle",
            "alignmentBaseline": "middle",
            "className": "messageText",
            "dy": "1em",
            "style": {
              "fontFamily": "\"Open Sans\", Helvetica, sans-serif",
              "fontSize": "13px",
              "fontWeight": "400"
            }
          }}>{`"We are honored by your presence..."`}</text><line parentName="svg" {...{
            "x1": "60",
            "y1": "205",
            "x2": "446",
            "y2": "205",
            "className": "messageLine1",
            "strokeWidth": "2",
            "stroke": "none",
            "markerEnd": "url(#arrowhead)",
            "style": {
              "strokeDasharray": "3, 3",
              "fill": "none"
            }
          }}></line><text parentName="svg" {...{
            "x": "253",
            "y": "220",
            "textAnchor": "middle",
            "dominantBaseline": "middle",
            "alignmentBaseline": "middle",
            "className": "messageText",
            "dy": "1em",
            "style": {
              "fontFamily": "\"Open Sans\", Helvetica, sans-serif",
              "fontSize": "13px",
              "fontWeight": "400"
            }
          }}>{`"You may dispense with the pleasantries, commander."`}</text><line parentName="svg" {...{
            "x1": "446",
            "y1": "245",
            "x2": "60",
            "y2": "245",
            "className": "messageLine0",
            "strokeWidth": "2",
            "stroke": "none",
            "markerEnd": "url(#arrowhead)",
            "style": {
              "fill": "none"
            }
          }}></line><g parentName="svg"><rect parentName="g" {...{
              "x": "85",
              "y": "255",
              "fill": "#EDF2AE",
              "stroke": "#666",
              "width": "120",
              "height": "35",
              "rx": "0",
              "ry": "0",
              "className": "note"
            }}></rect><text parentName="g" {...{
              "x": "145",
              "y": "260",
              "textAnchor": "middle",
              "dominantBaseline": "middle",
              "alignmentBaseline": "middle",
              "className": "noteText",
              "dy": "1em",
              "style": {
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif",
                "fontSize": "13px",
                "fontWeight": "400"
              }
            }}><tspan parentName="text" {...{
                "x": "145"
              }}>{`Oh s**t.`}</tspan></text></g><g parentName="svg"><rect parentName="g" {...{
              "x": "0",
              "y": "310",
              "fill": "#eaeaea",
              "stroke": "#666",
              "width": "120",
              "height": "40",
              "rx": "3",
              "ry": "3",
              "className": "actor"
            }}></rect><text parentName="g" {...{
              "x": "60",
              "y": "330",
              "dominantBaseline": "central",
              "alignmentBaseline": "central",
              "className": "actor",
              "style": {
                "textAnchor": "middle",
                "fontSize": "13px",
                "fontWeight": "400",
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif"
              }
            }}><tspan parentName="text" {...{
                "x": "60",
                "dy": "0"
              }}>{`Moff Jerjerrod`}</tspan></text></g><g parentName="svg"><rect parentName="g" {...{
              "x": "386",
              "y": "310",
              "fill": "#eaeaea",
              "stroke": "#666",
              "width": "120",
              "height": "40",
              "rx": "3",
              "ry": "3",
              "className": "actor"
            }}></rect><text parentName="g" {...{
              "x": "446",
              "y": "330",
              "dominantBaseline": "central",
              "alignmentBaseline": "central",
              "className": "actor",
              "style": {
                "textAnchor": "middle",
                "fontSize": "13px",
                "fontWeight": "400",
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif"
              }
            }}><tspan parentName="text" {...{
                "x": "446",
                "dy": "0"
              }}>{`Darth Vader`}</tspan></text></g><g parentName="svg"><rect parentName="g" {...{
              "x": "567",
              "y": "310",
              "fill": "#eaeaea",
              "stroke": "#666",
              "width": "120",
              "height": "40",
              "rx": "3",
              "ry": "3",
              "className": "actor"
            }}></rect><text parentName="g" {...{
              "x": "627",
              "y": "330",
              "dominantBaseline": "central",
              "alignmentBaseline": "central",
              "className": "actor",
              "style": {
                "textAnchor": "middle",
                "fontSize": "13px",
                "fontWeight": "400",
                "fontFamily": "\"Open Sans\", Helvetica, sans-serif"
              }
            }}><tspan parentName="text" {...{
                "x": "627",
                "dy": "0"
              }}>{`Lambda shuttle`}</tspan></text></g></svg></div>
    </FlowDiagram>
    <h2>{`Class Diagram`}</h2>
    <p>{`Although probably less likely to find its way into these documents than the
above variants, mermaid also supports the creation of UML-style class diagrams.`}</p>
    <FlowDiagram title="Class Diagram" mdxType="FlowDiagram">
      <div {...{
        "className": "mermaid",
        "data-processed": "true"
      }}><svg parentName="div" {...{
          "id": "mermaid-1630067668555",
          "width": "100%",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlnsXLink": "http://www.w3.org/1999/xlink",
          "height": "236",
          "style": {
            "maxWidth": "386.578125px"
          },
          "viewBox": "-20 -20 386.578125 236"
        }}><style parentName="svg">{`#mermaid-1630067668555{font-family:"Open Sans",Helvetica,sans-serif;font-size:13;fill:#ffffff;}#mermaid-1630067668555 .error-icon{fill:#c61d23;}#mermaid-1630067668555 .error-text{fill:#f7f7f7;stroke:#f7f7f7;}#mermaid-1630067668555 .edge-thickness-normal{stroke-width:2px;}#mermaid-1630067668555 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1630067668555 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1630067668555 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1630067668555 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1630067668555 .marker{fill:#ffffff;stroke:#ffffff;}#mermaid-1630067668555 .marker.cross{stroke:#ffffff;}#mermaid-1630067668555 svg{font-family:"Open Sans",Helvetica,sans-serif;font-size:13;}#mermaid-1630067668555 g.classGroup text{fill:#4cbfff;fill:#ffffff;stroke:none;font-family:"Open Sans",Helvetica,sans-serif;font-size:10px;}#mermaid-1630067668555 g.classGroup text .title{font-weight:bolder;}#mermaid-1630067668555 .classTitle{font-weight:bolder;}#mermaid-1630067668555 .node rect,#mermaid-1630067668555 .node circle,#mermaid-1630067668555 .node ellipse,#mermaid-1630067668555 .node polygon,#mermaid-1630067668555 .node path{fill:#006298;stroke:#4cbfff;stroke-width:1px;}#mermaid-1630067668555 .divider{stroke:#4cbfff;stroke:1;}#mermaid-1630067668555 g.clickable{cursor:pointer;}#mermaid-1630067668555 g.classGroup rect{fill:#006298;stroke:#4cbfff;}#mermaid-1630067668555 g.classGroup line{stroke:#4cbfff;stroke-width:1;}#mermaid-1630067668555 .classLabel .box{stroke:none;stroke-width:0;fill:#006298;opacity:0.5;}#mermaid-1630067668555 .classLabel .label{fill:#4cbfff;font-size:10px;}#mermaid-1630067668555 .relation{stroke:#ffffff;stroke-width:1;fill:none;}#mermaid-1630067668555 .dashed-line{stroke-dasharray:3;}#mermaid-1630067668555 #compositionStart,#mermaid-1630067668555 .composition{fill:#ffffff !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #compositionEnd,#mermaid-1630067668555 .composition{fill:#ffffff !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #dependencyStart,#mermaid-1630067668555 .dependency{fill:#ffffff !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #dependencyStart,#mermaid-1630067668555 .dependency{fill:#ffffff !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #extensionStart,#mermaid-1630067668555 .extension{fill:#ffffff !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #extensionEnd,#mermaid-1630067668555 .extension{fill:#ffffff !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #aggregationStart,#mermaid-1630067668555 .aggregation{fill:#006298 !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 #aggregationEnd,#mermaid-1630067668555 .aggregation{fill:#006298 !important;stroke:#ffffff !important;stroke-width:1;}#mermaid-1630067668555 .edgeTerminals{font-size:11px;}#mermaid-1630067668555:root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"></g><defs parentName="svg"><marker parentName="defs" {...{
              "id": "extensionStart",
              "className": "extension",
              "refX": "0",
              "refY": "7",
              "markerWidth": "190",
              "markerHeight": "240",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 1,7 L18,13 V 1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "extensionEnd",
              "refX": "19",
              "refY": "7",
              "markerWidth": "20",
              "markerHeight": "28",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 1,1 V 13 L18,7 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "compositionStart",
              "className": "extension",
              "refX": "0",
              "refY": "7",
              "markerWidth": "190",
              "markerHeight": "240",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 18,7 L9,13 L1,7 L9,1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "compositionEnd",
              "refX": "19",
              "refY": "7",
              "markerWidth": "20",
              "markerHeight": "28",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 18,7 L9,13 L1,7 L9,1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "aggregationStart",
              "className": "extension",
              "refX": "0",
              "refY": "7",
              "markerWidth": "190",
              "markerHeight": "240",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 18,7 L9,13 L1,7 L9,1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "aggregationEnd",
              "refX": "19",
              "refY": "7",
              "markerWidth": "20",
              "markerHeight": "28",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 18,7 L9,13 L1,7 L9,1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "dependencyStart",
              "className": "extension",
              "refX": "0",
              "refY": "7",
              "markerWidth": "190",
              "markerHeight": "240",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 5,7 L9,13 L1,7 L9,1 Z"
              }}></path></marker></defs><defs parentName="svg"><marker parentName="defs" {...{
              "id": "dependencyEnd",
              "refX": "19",
              "refY": "7",
              "markerWidth": "20",
              "markerHeight": "28",
              "orient": "auto"
            }}><path parentName="marker" {...{
                "d": "M 18,7 L9,13 L14,7 L9,1 Z"
              }}></path></marker></defs><g parentName="svg" {...{
            "id": "classid-Animal-0",
            "className": "classGroup",
            "transform": "translate(144.234375,0 )"
          }}><rect parentName="g" {...{
              "x": "0",
              "y": "0",
              "width": "81.5625",
              "height": "78",
              "className": ""
            }}></rect><text parentName="g" {...{
              "y": "15",
              "x": "0"
            }}><tspan parentName="text" {...{
                "className": "title",
                "x": "24"
              }}>{`Animal`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "21",
              "y2": "21",
              "x2": "81.5625"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "31",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`+int age`}</tspan><tspan parentName="text" {...{
                "x": "5",
                "dy": "10"
              }}>{`+String gender`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "47",
              "y2": "47",
              "x2": "81.5625"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "62",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`+isMammal()`}</tspan><tspan parentName="text" {...{
                "x": "5",
                "dy": "10"
              }}>{`+mate()`}</tspan></text></g><g parentName="svg" {...{
            "id": "classid-Duck-1",
            "className": "classGroup",
            "transform": "translate(0,128 )"
          }}><rect parentName="g" {...{
              "x": "0",
              "y": "0",
              "width": "96",
              "height": "68",
              "className": ""
            }}></rect><text parentName="g" {...{
              "y": "15",
              "x": "0"
            }}><tspan parentName="text" {...{
                "className": "title",
                "x": "35.546875"
              }}>{`Duck`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "21",
              "y2": "21",
              "x2": "96"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "31",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`+String beakColor`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "37",
              "y2": "37",
              "x2": "96"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "52",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`+swim()`}</tspan><tspan parentName="text" {...{
                "x": "5",
                "dy": "10"
              }}>{`+quack()`}</tspan></text></g><g parentName="svg" {...{
            "id": "classid-Fish-2",
            "className": "classGroup",
            "transform": "translate(146,133 )"
          }}><rect parentName="g" {...{
              "x": "0",
              "y": "0",
              "width": "78.03125",
              "height": "58",
              "className": ""
            }}></rect><text parentName="g" {...{
              "y": "15",
              "x": "0"
            }}><tspan parentName="text" {...{
                "className": "title",
                "x": "28.734375"
              }}>{`Fish`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "21",
              "y2": "21",
              "x2": "78.03125"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "31",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`-int sizeInFeet`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "37",
              "y2": "37",
              "x2": "78.03125"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "52",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`-canEat()`}</tspan></text></g><g parentName="svg" {...{
            "id": "classid-Zebra-3",
            "className": "classGroup",
            "transform": "translate(274.03125,133 )"
          }}><rect parentName="g" {...{
              "x": "0",
              "y": "0",
              "width": "72.546875",
              "height": "58",
              "className": ""
            }}></rect><text parentName="g" {...{
              "y": "15",
              "x": "0"
            }}><tspan parentName="text" {...{
                "className": "title",
                "x": "22.4375"
              }}>{`Zebra`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "21",
              "y2": "21",
              "x2": "72.546875"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "31",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`+bool is_wild`}</tspan></text><line parentName="g" {...{
              "x1": "0",
              "y1": "37",
              "y2": "37",
              "x2": "72.546875"
            }}></line><text parentName="g" {...{
              "x": "5",
              "y": "52",
              "fill": "white",
              "className": "classText"
            }}><tspan parentName="text" {...{
                "x": "5"
              }}>{`+run()`}</tspan></text></g><path parentName="svg" {...{
            "d": "M144.234375,58.04892234006158L128.1953125,65.54076861671798C112.15625,73.03261489337439,80.078125,88.01630744668721,64.0390625,99.67482039001027C48,111.33333333333333,48,119.66666666666667,48,123.83333333333333L48,128",
            "id": "edge0",
            "className": "relation",
            "markerStart": "url(#extensionStart)"
          }}></path><g parentName="svg" {...{
            "className": "cardinality"
          }}><text parentName="g" {...{
              "className": "type1",
              "x": "128.67688870382665",
              "y": "54.27869421110465",
              "fill": "black",
              "fontSize": "6"
            }}>{`1`}</text></g><path parentName="svg" {...{
            "d": "M185.015625,78L185.015625,82.16666666666667C185.015625,86.33333333333333,185.015625,94.66666666666667,185.015625,103.83333333333333C185.015625,113,185.015625,123,185.015625,128L185.015625,133",
            "id": "edge1",
            "className": "relation",
            "markerStart": "url(#extensionStart)"
          }}></path><path parentName="svg" {...{
            "d": "M225.796875,59.831826401446655L239.88151041666666,67.02652200120555C253.96614583333334,74.22121760096444,282.1354166666667,88.61060880048223,296.2200520833333,100.80530440024113C310.3046875,113,310.3046875,123,310.3046875,128L310.3046875,133",
            "id": "edge2",
            "className": "relation",
            "markerStart": "url(#dependencyStart)",
            "markerEnd": "url(#aggregationEnd)"
          }}></path></svg></div>
    </FlowDiagram>
    <h2>{`Schematic Drawing`}</h2>

    <p>{`A more flexible capability to display screens exists in the use of
Scalable Vector Graphics, a widely supported drawing program export format.`}</p>
    <Schematic title="SVG Schematic Drawing" annotations={[{
      id: "cam-example",
      target: "CAM-PleaseWaitBox",
      text: "Click this annotation to highlight a described part of the drawing",
      mask: true
    }]} mdxType="Schematic">
  <CamExampleDrawing style={{
        maxWidth: 400
      }} mdxType="CamExampleDrawing" />
    </Schematic>
    <p>{`Future development may support limited software interaction with SVG
files, such as the display of annotations that highlight or point to the
element or area of interest.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      